class Auth{
    constructor(){
        this.authenticated = false;
        this.current = false;
    }

    setCurrent(current){
        this.current = current;
    }

    getCurrent(){
        return this.current;
    }

    oauthAccessToken(appCode, clientID, cb){
        fetch(localStorage.getItem('server') + 'oauth?grant_type=api&client_id=' + clientID + '&code=' + appCode, {
            method: 'POST'
        })
        .then((resp)=>{
            return resp.json();
        })
        .then((data)=>{
            cb(data);
        })
    }

    async oauthLogin (memberNumber, mobileNumber, pinNumber, dob, clientID, redirectURI){
        const body = {
            memberNumber,
            mobileNumber,
            pinNumber,
            clientID,
            redirectURI,
            dob
        };
        const response = await fetch(localStorage.getItem('server') + 'oauth/login', {
            method: 'POST',
            body: JSON.stringify(body)
        });
        //console.info('respp frm oauthLogin in auth.js ', response);
        const data = await response.json();        
        return data;
    }

    
    //validate mobile number:
    validateMobileNumber(mobileNumber){

        if(mobileNumber.length !== 10){
            return 'mobile number must be 10 digit';
        }
        else if (mobileNumber[0] !== '0' || mobileNumber[1] !== '4'){
            return 'mobile number should begin with 04';
        }

        return 'ok';
    }

    //Generate OTP
    async generateOTP(mobileNumber, successCallback, failCallback, regoID=2) {
        try {
          const valid = this.validateMobileNumber(mobileNumber);
          console.log('valid:', valid);
          if(valid !== 'ok'){
            throw new Error('Mobile number is not in valid format');
          }
  
          const DTO = { mobileNumber };
          const response = await fetch(
            localStorage.getItem("server") + "generateOTP",
            {
              headers: {
                "Content-Type": "application/json",
                regoID,
              },
              method: "POST",
              body: JSON.stringify(DTO),
            }
          );
          const data = await response.json();
  
          if(data.status === 200){
           successCallback();
          }
          else{
            throw new Error('code not 200');
          }
        } catch (exception) {
          console.error(exception);
          failCallback();
        } 
        
    }

    //confirm OTP
    async confirmOTP(DTO, regoID, counter) {   
    
        try {
          const response = await fetch(
            localStorage.getItem("server") + "otpLogin",
            {
              method: "POST",
              headers: {
                regoID,
              },
              body: JSON.stringify(DTO),
            }
          );
    
          const data = await response.json();
    
          if (data.status === 401) {
            if(counter < 3){
            data.message = "Your request cannot be processed. Please check whether the verification code you provided was correct and try again."
                
            }
            else {
              data.message = "You have reached the maximum attempt to confirm your verification code. Please try again later or contact us at 9722 9888."
            }

            return data; 
          }
          else if (data.status === 200){
            return data;       
          } 
          else{
            throw new Error('Status not 200 or 401');
          }
    
        } catch (error) {
          console.error(error);
        } 
      }
    


    //Authenticating OTP - Henry's
    authenticateOTP(otp, mobile, cb){
        var that = this;
        fetch(localStorage.getItem('server') + 'otpLogin', {
            method: 'POST',
            headers: {
                'regoID': 2
            },
            body: JSON.stringify({
                'pinNumber': otp,
                'mobileNumberContext': mobile
            })
        })
        .then((response)=>{
            return response.json();
        })
        .then((data)=>{
            if(data.success){
                that.authenticated = true;
                
                sessionStorage.setItem('loggedIn', true);
                sessionStorage.setItem('token', data.AuthToken);
                sessionStorage.setItem('cardNumber', data.cardNumber.toString());
                cb(true, data.memberNumber);
            } else {
                that.authenticated = false;
                sessionStorage.setItem('loggedIn', false);
                sessionStorage.removeItem('token');
                cb(false);
            }
        });
    }    

    //Handle logout
    logout(cb){
        this.authenticated = false;
        sessionStorage.setItem("loggedIn", false);
        cb();
    }

    isAuthenticated() {
        // return this.authenticated;
        return sessionStorage.getItem("loggedIn");
    }

    getTestVar(){
        return this.testVariable;
    }
}

export default new Auth();